import { ICreateSendLinkActionState } from '../types/createSendLinkAction';

export const DEFAULT_CREATE_SEND_LINK_ACTION_STATE: ICreateSendLinkActionState = {
  target: null,
  generation: 0,
};
